import { UnitActivationsInfiniteView } from '@apps-common/apps/portal/pages/units/pages/activations/components/activations-infinite'
import { UnitActivationsTableView } from '@apps-common/apps/portal/pages/units/pages/activations/components/activations-table'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'
import { UnitActivationProvider } from '@apps-common/contexts'
import { IonPage } from '@ionic/react'

export const UnitActivationsPage: React.FC = () => (
  <IonPage>
    <UnitActivationProvider>
      <MobileViewSwitcher desktopView={<UnitActivationsTableView />} mobileView={<UnitActivationsInfiniteView />} />
    </UnitActivationProvider>
  </IonPage>
)
